/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import EditableText from 'material/embeds/editabletext/editabletext_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/question/question_styles';



/* ========== ~~~~~~~~~~ EMBED : QUESTION ~~~~~~~~~~ ========== */
class Question extends Component {
	constructor(props) {
		super(props);
		this.questionEl = null;
		this.characterLimit = 134; // 134 from UX (Will)
		this.state = { fontSize: 'standard' };
		this.availableQuesSizes = ['standard', 'medium', 'small', 'xsmall', 'xxsmall', 'xxxsmall', 'x4small', 'x5small', 'x6small', 'x7small', 'x8small']; // array of all available font sizes
	}

	componentDidMount() {
		this.validateText({ text: this.props.contentTitle, initialValidation: true });
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.contentId !== this.props.contentId) this.validateText({ text: this.props.contentTitle, initialValidation: true });
	}

	adjustFontSize({ resetSize }) {
		if(!this.questionEl) return null;
		// Reset font size on text change
		if(resetSize && this.state.fontSize !== 'standard') return this.setQuestionSize('standard');
		let currQuesSize = this.state.fontSize;
		const currQuesSizeIndex = this.availableQuesSizes.indexOf(currQuesSize);
		const heightDifference = this.getQuestionContainerDimensions().height - this.getQuestionElementDimensions().height;
		if (heightDifference < 4) {
			currQuesSize = this.availableQuesSizes[currQuesSizeIndex + 1] ? this.availableQuesSizes[currQuesSizeIndex + 1] : currQuesSize;
			this.setQuestionSize(currQuesSize);
		}
	}

	setQuestionSize = currQuesSize => {
		if (this.state.fontSize !== currQuesSize) {
			this.setState({fontSize: currQuesSize }, () => this.adjustFontSize({ resetSize: false }));
		}
	};

	getQuestionContainerDimensions() {
		const el = this.questionEl;
		let height = el.clientHeight;
		return { width: el.clientWidth, height: height };
	}

	getQuestionElementDimensions() {
		const el = this.questionEl.firstChild;
		return { width: el.clientWidth, height: el.clientHeight };
	}

	runValidation = text => this.validateText({ text, initialValidation: false });

	validateText = ({ text, initialValidation }) => {
		const trimmedText = text !== null ? text.trim() : '';
        const isValid = this.props.isValid;
        if(trimmedText.length > this.characterLimit || (initialValidation && isValid === null)) return null;
		this.adjustFontSize({ resetSize: true });

		if (trimmedText.length > 0 && !isValid) {
			this.props.setQBProperty(this.props.contentId, 'isTitleValid', true)
		} else if (trimmedText.length === 0 && (isValid || isValid === null)) {
			this.props.setQBProperty(this.props.contentId, 'isTitleValid', false)
		}
	};

	handleSelect = () => {
		if(!this.props.isValid) { this.props.setQBProperty(this.props.contentId, 'isTitleValid', null) }
	};

	render() {
		const placeholderText = 'Type your question here';
		return(
			<div  className={`question ${this.props.classes.question} valid-${this.props.isValid}`}>
				<h3 className={`text ${this.state.fontSize}`} ref={(input) => this.questionEl = input}>
					<EditableText
                        key={`${this.props.isEditable ? `editor` : `card`}-question-${this.props.contentId}`}
						contentId={this.props.contentId}
						textValue={this.props.contentTitle}
						textType={'question'}
						isEditable={this.props.isEditable}
						isOption={false}
						optionId={null}
						placeholderText={placeholderText}
						onKeyUp={this.runValidation}
						onBlur={this.runValidation}
						onFocus={this.handleSelect}
						isSelected={true}
						preventEnter={true}
						characterLimit={this.characterLimit}
						validateText={this.runValidation}
					/>
				</h3>
			</div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Question);
